<template>
  <table class="table table-striped table-hover" id="searchTable-table">
    <thead id="searchTable-tableHead">
      <tr id="searchTable-tableRow">
        <th class="tcol-6">ID</th>
        <th class="tcol-14">Branche</th>
        <th class="tcol-10" v-if="isAllCases">Status</th>
        <th class="tcol-14" v-if="isArchivedCases">Geselecteerde verzekeraar</th>
        <th class="tcol-14">Batch</th>
        <th class="tcol-14">Geselecteerde Dekkingen</th>
        <th>Validatieregels</th>
        <th class="tcol-10" v-if="isClosedCases">Closed reason</th>
      </tr>
    </thead>
    <tbody id="searchTable-tableBody">
      <template v-for="c in caseList">
        <search-table-row
          v-bind:status="status"
          v-bind:caseObj="c"
          :productLines="productLines"
          id="searchTable-searchTableRow">
        </search-table-row>
      </template>
    </tbody>
  </table>
</template>
<script>
import SearchTableRow from '@/components/search/SearchTableRow';
export default {
  props: ['status', 'caseList', 'productLines'],
  components: {
    'search-table-row': SearchTableRow
  },
  computed: {
    isAllCases: function() {
      return this.status === 'all';
    },
    isOpenCases: function() {
      return this.status === 'open';
    },
    isArchivedCases: function() {
      return this.status === 'archived';
    },
    isClosedCases: function() {
      return this.status === 'closed';
    }
  }
}
</script>
<style scoped>
  table {
    font-size: 14px;
    table-layout: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/search/SearchTable.vue